
import { Box, CircularProgress, Divider, Modal, Typography } from '@mui/material';
import { useModalStore } from '../../../stores';






export const ModalFormulario = ({ titulo="Sin Titulo", onClose, valor, color='white', children }) => {


    const { modalForm } = useModalStore();;


    return (

        <Modal aria-labelledby="transition-modal-title" open={modalForm} onClose={onClose} closeAfterTransition>
            <>
            {(valor)
            ?   <Box className="modal-estilo" sx={{ width:{xs:'87%', sm:'65%', md:'50%'}, 
                    maxHeight:'90vh', borderRadius:3, display:'flex', flexDirection:'column', overflow:'hidden'
                }}>
                    <Box sx={{ px:3, pt:2, flexShrink:0 }}>
                        <Typography variant='h2' align='center' sx={{ mb:1 }}>
                            {titulo}
                        </Typography>
                        <Divider sx={{ mb:1 }} />
                    </Box>

                    <Box sx={{ px:3, pb:3, pt:2, overflowY:'auto', flexGrow:1 }}>
                        { children }
                    </Box>
                </Box>

            :   <Box sx={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:'100%', height:'100%' }}>
                    <CircularProgress size="50px" />
                    <Typography sx={{ fontSize:23, mt:2, color: color }}>
                        Cargando Información...
                    </Typography>
                </Box>
            }
            </>
        </Modal>

    );







}